import { render } from "./LuckyNumberRules.vue?vue&type=template&id=294cc99d"
import script from "./LuckyNumberRules.vue?vue&type=script&lang=js"
export * from "./LuckyNumberRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__